import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./SocialL1.module.css";

function SocialL1({ distrito }) {
  const [rendaExclusiva, setRendaExclusiva] = useState(null);
  const [creditoRural, setCreditoRural] = useState(null);
  const [possuiEmpresa, setPossuiEmpresa] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [rendaExclusiva, creditoRural, possuiEmpresa] = await Promise.all(
          [
            Api.getRendaExclusiva(distrito),
            Api.getCreditoRural(distrito),
            Api.getPossuiEmpresa(distrito),
          ]
        );
        setRendaExclusiva(Functions.buildSmallPieGraphParams(rendaExclusiva));
        setCreditoRural(Functions.buildSmallPieGraphParams(creditoRural));
        setPossuiEmpresa(Functions.buildSmallPieGraphParams(possuiEmpresa));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };
  return (
    <div className={styles.socialL1}>
      <div className={styles.smallPiegraph}>
        {rendaExclusiva && (
          <SmallPieGraph
            data={rendaExclusiva}
            text="RENDA EXCLUSIVA"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {creditoRural && (
          <SmallPieGraph
            data={creditoRural}
            text="CRÉDITO RURAL"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {possuiEmpresa && (
          <SmallPieGraph
            data={possuiEmpresa}
            text="POSSUI EMPRESA"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
    </div>
  );
}

export default SocialL1;
